import React from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { BUILD_ENVIRONMENT } from 'Settings';

import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const SiteHeaderLink = props => {
  const Component = () => {
    const { id, route, externalLink, type, buttonType } = props;
    const label = <ConnectedFormattedMessage id={`site_nav.label.${id}`} />;

    if (type === 'button') {
      const additionalClasses = props.additionalClasses || '';
      const fungibleProps = { ...props, label };
      if (route === ROUTES.FREE_TRIAL && BUILD_ENVIRONMENT === 'demo') {
        delete fungibleProps.route;
        fungibleProps.externalLink = 'https://schools.tinybop.com/free-trial';
      }

      return (
        <Button {...fungibleProps} additionalClasses={`${additionalClasses}`} />
      );
    }

    if (externalLink) {
      return (
        <a href={externalLink} className="SiteNav__link">
          {label}
        </a>
      );
    }

    return (
      <NavLink to={route} className="SiteNav__link" activeClassName="is-active">
        {label}
      </NavLink>
    );
  };

  return (
    <div className="SiteNav__item">
      <Component />
    </div>
  );
};

export default withRouter(SiteHeaderLink);
